import type { NodeModel } from "@/models/nodes/types";
import type { NodeJson } from "@corca/data";

export function removeNodeIds(node: NodeModel | NodeJson): NodeJson {
  const strip = ({ id: _id, children, ...rest }: NodeJson): NodeJson => {
    return {
      ...rest,
      ...(children && { children: children.map(strip) }),
    } as NodeJson;
  };

  return strip("toJSON" in node ? node.toJSON() : node);
}
